import { request } from "../client";

import type {
  AnalyticsPeriod,
  AdminDashboardOverview,
  CampaignAttributionReport,
  ProductAnalytics,
  LandingFunnelReport,
  LanguageDemandReport,
  UserActivityReport,
} from "@lingoshade/domain";

export function createAdminAnalyticsEndpoints(baseUrl: string): {
  languageDemand: (
    days: AnalyticsPeriod,
    token: string,
  ) => Promise<LanguageDemandReport>;
  landingFunnel: (
    days: AnalyticsPeriod,
    token: string,
  ) => Promise<LandingFunnelReport>;
  dashboard: (token: string) => Promise<AdminDashboardOverview>;
  report: (days: AnalyticsPeriod, token: string) => Promise<ProductAnalytics>;
  campaignAttribution: (
    days: AnalyticsPeriod,
    token: string,
  ) => Promise<CampaignAttributionReport>;
  userActivity: (
    userId: string,
    days: AnalyticsPeriod,
    page: number,
    token: string,
  ) => Promise<UserActivityReport>;
} {
  return {
    languageDemand: (days, token): Promise<LanguageDemandReport> =>
      request(baseUrl, "/admin/language-demand", { query: { days }, token }),
    landingFunnel: (days, token): Promise<LandingFunnelReport> =>
      request(baseUrl, "/admin/landing-funnel", { query: { days }, token }),
    dashboard: (token): Promise<AdminDashboardOverview> =>
      request(baseUrl, "/admin/dashboard", { token }),
    report: (days, token): Promise<ProductAnalytics> =>
      request(baseUrl, "/admin/product-analytics", { query: { days }, token }),
    campaignAttribution: (days, token): Promise<CampaignAttributionReport> =>
      request(baseUrl, "/admin/campaign-attribution", {
        query: { days },
        token,
      }),
    userActivity: (userId, days, page, token): Promise<UserActivityReport> =>
      request(baseUrl, `/admin/users/${encodeURIComponent(userId)}/activity`, {
        query: { days, page },
        token,
      }),
  };
}
